"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconDots = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconDots = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M11.846 7.692a1.85 1.85 0 001.846-1.846c0-1.015-.83-1.846-1.846-1.846C10.831 4 10 4.83 10 5.846s.83 1.846 1.846 1.846zm0 2.462c-1.015 0-1.846.83-1.846 1.846 0 1.015.83 1.846 1.846 1.846s1.846-.83 1.846-1.846c0-1.015-.83-1.846-1.846-1.846zm0 6.154c-1.015 0-1.846.83-1.846 1.846 0 1.015.83 1.846 1.846 1.846s1.846-.83 1.846-1.846-.83-1.846-1.846-1.846z"
}));
exports.IconDots = IconDots;
//# sourceMappingURL=IconDots.js.map